import React, { useState } from "react"
import OrderReport from "./Tabs/OrderReport"
import { Container, ReportTableWrapper } from "./reportsStyled"
import { AppBar, Box, Tab, Tabs, Typography } from "@material-ui/core";
import { Heading } from "../../adminStyled";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import Breadcrumb from "web/components/Breadcrumb";

const PtplusReports = ({downloadPTPlusReportCSV, isDownloadingPtPlusOrderReportCSV}) => {
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [value, setValue] = useState(0);

  let breadcrumbMapArr = [
    {
      name: "PT+ Admin",
      link: "ptplus-user-managememt",
      eventType: "",
    },
  ];

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            {/* <Typography>{children}</Typography> */}
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  //change tab index
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PT_PLUS'))) ?
        <Container>
          <Breadcrumb
                breadcrumbArr={breadcrumbMapArr}
                selected='Reports'
                title=""
              />
          <ReportTableWrapper>
            {(loaderVisible) && <Spinner />}
            <div className="column">
              <Heading>
                <h3>Reports</h3>
              </Heading>
            </div>

            <AppBar position="static">
              <Tabs value={value} onChange={handleChangeTab} aria-label="simple tabs example">
                <Tab label="Orders" {...a11yProps(0)} />
                <Tab label="Pickup Orders" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            <OrderReport
              TabPanel={TabPanel}
              tabValue={value}
              downloadPTPlusReportCSV={downloadPTPlusReportCSV}
              isDownloadingPtPlusOrderReportCSV={isDownloadingPtPlusOrderReportCSV}
            />
          </ReportTableWrapper>
        </Container>
        :
        <p>You are not authorized to view this page.</p>
      }
    </>
  )
}

export default PtplusReports